import { IconMapPin as TablerIconMapPin } from '@tabler/icons-react';

import { createOutlineIcon } from '@/components/icon/createOutlineIcon';

export const IconMapPin = /*#__PURE__*/ createOutlineIcon(TablerIconMapPin, 'IconMapPin');
